import { html, ref } from "@microsoft/fast-element";
import { FluentButton } from "@fluentui/web-components";
import { startTemplate } from "@microsoft/fast-foundation";
// Prevent tree shaking
FluentButton;
export const SearchBoxTemplate = html `
    <template
        role="textbox"
        aria-required="${x => x.required}"
        aria-disabled="${x => x.disabled}"
        aria-readonly="${x => x.readOnly}"
        aria-label="${x => x.title}"
        tabindex="${x => (x.disabled ? null : 0)}"
        class="
            ${x => (x.readOnly ? "readonly" : "")}
            ${x => (x.onImage ? "onimage" : "")}
        "
    >
        <div class="root" part="root">
            ${startTemplate}
            <input
                class="control"
                part="control"
                type="search"
                id="${x => x.id}"
                title="${x => x.title}"
                name="${x => x.name}"
                @input=${x => x.handleTextInput()}
                placeholder=${x => x.placeholder}
                autocomplete=${x => x.autocomplete}
                ?required=${x => x.required}
                ?disabled=${x => x.disabled}
                ?readonly=${x => x.readOnly}
                maxlength="${x => x.maxlength}"
                minlength="${x => x.minlength}"
                ?spellcheck="${x => x.spellcheck}"
                :value="${x => x.value}"
                ${ref("control")}
            />
        </div>
        <fluent-button
            tabIndex=${x => (x.disabled ? "-1" : "0")}
            appearance="${x => (x.onImage ? "stealth" : "accent")}"
            @click="${x => x.submitSearch()}"
            @keypress="${x => x.submitSearch()}"
        >
            <span part="end" ${ref("endContainer")}>
                <slot
                    name="end"
                    ${ref("end")}
                    @slotchange=${x => x.handleEndContentChange()}
                >
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M13.125 0C13.7565 0 14.3652 0.0813802 14.9512 0.244141C15.5371 0.406901 16.084 0.638021 16.5918 0.9375C17.0996 1.23698 17.5618 1.59831 17.9785 2.02148C18.4017 2.43815 18.763 2.90039 19.0625 3.4082C19.362 3.91602 19.5931 4.46289 19.7559 5.04883C19.9186 5.63477 20 6.24349 20 6.875C20 7.50651 19.9186 8.11523 19.7559 8.70117C19.5931 9.28711 19.362 9.83398 19.0625 10.3418C18.763 10.8496 18.4017 11.3151 17.9785 11.7383C17.5618 12.1549 17.0996 12.513 16.5918 12.8125C16.084 13.112 15.5371 13.3431 14.9512 13.5059C14.3652 13.6686 13.7565 13.75 13.125 13.75C12.3112 13.75 11.5299 13.6133 10.7812 13.3398C10.0391 13.0664 9.35547 12.6725 8.73047 12.1582L1.06445 19.8145C0.940755 19.9382 0.794271 20 0.625 20C0.455729 20 0.309245 19.9382 0.185547 19.8145C0.061849 19.6908 0 19.5443 0 19.375C0 19.2057 0.061849 19.0592 0.185547 18.9355L7.8418 11.2695C7.32747 10.6445 6.93359 9.96094 6.66016 9.21875C6.38672 8.47005 6.25 7.6888 6.25 6.875C6.25 6.24349 6.33138 5.63477 6.49414 5.04883C6.6569 4.46289 6.88802 3.91602 7.1875 3.4082C7.48698 2.90039 7.84505 2.43815 8.26172 2.02148C8.6849 1.59831 9.15039 1.23698 9.6582 0.9375C10.166 0.638021 10.7129 0.406901 11.2988 0.244141C11.8848 0.0813802 12.4935 0 13.125 0ZM13.125 12.5C13.8997 12.5 14.6289 12.3535 15.3125 12.0605C15.9961 11.7611 16.5918 11.3574 17.0996 10.8496C17.6074 10.3418 18.0078 9.74609 18.3008 9.0625C18.6003 8.37891 18.75 7.64974 18.75 6.875C18.75 6.10026 18.6003 5.37109 18.3008 4.6875C18.0078 4.00391 17.6074 3.4082 17.0996 2.90039C16.5918 2.39258 15.9961 1.99219 15.3125 1.69922C14.6289 1.39974 13.8997 1.25 13.125 1.25C12.3503 1.25 11.6211 1.39974 10.9375 1.69922C10.2539 1.99219 9.6582 2.39258 9.15039 2.90039C8.64258 3.4082 8.23893 4.00391 7.93945 4.6875C7.64648 5.37109 7.5 6.10026 7.5 6.875C7.5 7.64974 7.64648 8.37891 7.93945 9.0625C8.23893 9.74609 8.64258 10.3418 9.15039 10.8496C9.6582 11.3574 10.2539 11.7611 10.9375 12.0605C11.6211 12.3535 12.3503 12.5 13.125 12.5Z"
                        />
                    </svg>
                </slot>
            </span>
        </fluent-button>
    </template>
`;
